import { Extension } from '@tiptap/core';

/**
 * Per-editor runtime storage (`editor.storage.quillRuntime`). The extension list is built
 * once per editor and memoized, so values that change with React props (mode, placeholder,
 * callbacks) are written here by the host component and read lazily by extensions, node
 * views and the slash menu instead of being baked into extension options.
 */
const EditorRuntime = Extension.create({
  name: 'quillRuntime',

  addStorage() {
    return {
      /** 'document' | 'template' */
      mode: 'document',
      /** Placeholder for an empty document. */
      placeholder: '',
      /** Whether images can be inserted. */
      enableImages: true,
      /** Field id whose edit popover should open once its node view mounts. */
      pendingEditFieldId: null,
      /** True while an AI review is shown. */
      reviewActive: false,
      /**
       * Host callbacks: { openImagePicker, openInlineAi, openFind, openShortcuts,
       * onRegenerateField, insertTable }.
       */
      callbacks: {},
    };
  },
});

export default EditorRuntime;
